import { render, staticRenderFns } from "./SnackbarPagoPendiente.vue?vue&type=template&id=ac0ebe34"
import script from "./SnackbarPagoPendiente.vue?vue&type=script&lang=ts"
export * from "./SnackbarPagoPendiente.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports